import React from 'react';
import WorkCard from './WorkCard';

const Work = () => {
    return (
        <div>
            <h1 className='text-center  font-medium text-2xl mt-5 text-yellow-400 '>How Im Work</h1>

            <div className=''>
              <WorkCard></WorkCard>  
            </div>
        </div>
    );
};

export default Work;